import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { SupportButtonsComponent } from '@shared/components/support-buttons/support-buttons.component';
import { FaqFooterComponent } from '@shared/components/faq/faq-footer/faq-footer.component';

@Component({
  selector: 'app-weblayout',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent, FooterComponent, SupportButtonsComponent, FaqFooterComponent,
    RouterOutlet
  ],
  templateUrl: './web-layout.component.html',
  styleUrl: './web-layout.component.scss'
})
export class WebLayoutComponent {

}
